export default {
  title: 'Stampa ricevute',
  sections: {
    destination: 'Stampa ricevute su',
  },
  printers: {
    inner: {
      title: 'Stampante integrata',
    },
    external: {
      title: 'Stampante esterna',
      width_unset: 'Larghezza carta non impostata',
      connect_hint: 'Collega una stampante per utilizzarla',
      disconnect_confirm: 'Disconnettere questa stampante?',
      disconnect_confirm_description: 'Dovrai configurarla di nuovo.',
      disconnect_confirm_ok: 'Sì, disconnetti',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Pronta',
      title: 'Pronta per la stampa',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Carta in esaurimento',
      title: 'La carta è quasi esaurita',
      description: 'Sostituire il rotolo presto. La stampa continua.',
    },
    busy: {
      label: 'Occupata',
      title: 'Stampante occupata',
      description: '{{name}} sta completando un altro lavoro.',
    },
    not_configured: {
      label: 'Non configurata',
      title: 'Non configurata',
      description: '{{name}} deve essere configurata prima di poter stampare.',
    },
    offline: {
      label: 'Offline',
      title: 'Non stampa',
      description: '{{name}} è offline. I nuovi ordini non vengono stampati.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} non è connessa.',
    },
    cover_open: {
      label: 'Sportello aperto',
      title: 'Lo sportello è aperto',
      description: 'Chiudi lo sportello della stampante per riprendere la stampa.',
    },
    paper_empty: {
      label: 'Carta esaurita',
      title: 'Carta esaurita',
      description: 'Sostituire il rotolo per riprendere la stampa.',
    },
    wrong_paper: {
      label: 'Carta errata',
      title: 'Carta errata',
      description: 'Il rotolo caricato non corrisponde alla larghezza carta configurata.',
    },
    cutter_error: {
      label: 'Errore taglierina',
      title: 'Errore taglierina',
      description: 'Controllare la taglierina per carta inceppata, quindi riprovare.',
    },
    overheat: {
      label: 'Troppo calda',
      title: 'Stampante troppo calda',
      description: 'Lascia raffreddare {{name}} prima di stampare di nuovo.',
    },
    error: {
      label: 'Errore',
      title: 'Errore stampante',
      description: '{{name}} ha segnalato un errore e richiede attenzione.',
    },
    connecting: {
      label: 'Connessione in corso…',
      title: 'Connessione in corso…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Non connessa',
      title: 'Non connessa',
      description: '{{name}} non è connessa.',
    },
  },
  form: {
    auto_print: {
      label: 'Stampa automatica nuovi ordini',
      not_ready:
        'La stampa automatica è attiva ma la stampante esterna non è pronta. Gli ordini non verranno stampati.',
    },
    print_copies: {
      label: 'Copie per ordine',
      hint: 'Attiva la stampa automatica per impostare le copie',
      decrease: 'Diminuisci copie',
      increase: 'Aumenta copie',
    },
  },
  toasts: {
    failed_to_save_changes: 'Impossibile salvare le modifiche',
  },
  buttons: {
    test_print: 'Stampa di prova',
    configure_external: 'Configura',
    connect_external: 'Collega una stampante',
    disconnect_external: 'Disconnetti',
    retry_connection: 'Riprova connessione',
    cancel: 'Annulla',
  },
};
